import React from 'react';
import TenantManagement from '../TenantManagement/TenantManagement';
import { useNavigate } from 'react-router-dom';
import style from './TenantsManagementView.module.css';

const TenantsManagementView = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/alquileres');
  };

  return (
    <div className={style.viewContainer}>
      <TenantManagement onClose={handleClose} />
    </div>
  );
};

export default TenantsManagementView;
